import type { QueryKey } from "@tanstack/react-query";

/**
 * Query-key factory for the storage photos feature. Deliberately its own
 * namespace, not nested under `storageQueryKeys`, so the two features stay
 * independent: invalidating `storageQueryKeys.all` does NOT reach photos.
 */
export const storagePhotosQueryKeys = {
  all: ["storage-photos"] as QueryKey,
  // Photos for one item, keyed by the numeric storage id (fetched by uuid).
  // Note list() with no arg does NOT work as a blanket prefix: it produces
  // { storage_id: undefined }, which react-query partial matching never
  // matches against a real id. Use `all` for that.
  list: (storageId?: number): QueryKey => [
    "storage-photos",
    "list",
    { storage_id: storageId },
  ],
};
